// @flow

import { commitMutation, graphql } from 'react-relay';
import relayEnvironment from 'shared/gql/relayEnvironment';

const mutation = graphql`
  mutation GeneratePOsForOrdersMutation {
    generatePOsForOrders {
      purchaseOrders {
        node {
          id
          poNumber
          vendor {
            id
            name
          }
          status
          totalAmount
        }
      }
      itemsProcessed
    }
  }
`;

function commit(input: {}, callbacks: Object) {
  return commitMutation(relayEnvironment, {
    mutation,
    variables: {},
    onCompleted: (response, errors) => {
      if (errors) {
        callbacks.onFailure && callbacks.onFailure(errors[0]);
      } else {
        callbacks.onSuccess && callbacks.onSuccess(response);
      }
    },
    onError: error => {
      callbacks.onFailure && callbacks.onFailure(error);
    },
  });
}

export default { commit };
